import { Checkbox, Form, Header, Radio } from "semantic-ui-react";
import ErrorsView from "./ErrorsView";
import { FormError } from "../models/FormError";
import { DocumentRequirementKey } from "../models/globalTypes";
import { DocumentRequirementKeyList } from "../models/DocumentRequirementKey";

export interface FormData {
  useDefault: boolean;
  declaration: string;
  requirementKey: DocumentRequirementKey;
}

interface Props {
  formData: FormData;
  formErrors: FormError;
  errors: string[] | undefined;
  onChange: (formData: FormData) => void;
}

const EditPermitTypeDocumentTypeSettingsForm = ({ formData, formErrors, errors, onChange }: Props) => {
  const handleCheckboxChange = (_: any, { name, checked }: any) => {
    onChange({ ...formData, [name]: checked });
  };

  const handleChange = (_: any, { name, value }: any) => {
    onChange({ ...formData, [name]: value });
  };

  return (
    <>
      <Form>
        <Form.Field>
          <Checkbox
            name="useDefault"
            checked={formData.useDefault}
            label="Use default org-level settings"
            onChange={handleCheckboxChange}
          />
        </Form.Field>
        <Header as="h5" dividing>
          Document type settings
        </Header>
        <Form.Group widths="equal">
          <Form.Field>
            <Form.Input
              label="Declaration text for when a document of this type is added to a permit (optional)"
              name="declaration"
              value={formData.declaration}
              placeholder="Declaration"
              disabled={formData.useDefault}
              onChange={handleChange}
              error={formErrors.declaration}
            />
          </Form.Field>
        </Form.Group>
        <Form.Group grouped>
          <Form.Field required>
            <label>When is this document required?</label>
          </Form.Field>
          <Form.Field error={formErrors.requirementKey}>
            <Radio
              label={DocumentRequirementKeyList.NONE.name}
              name="requirementKey"
              value={DocumentRequirementKeyList.NONE.key}
              checked={formData.requirementKey === DocumentRequirementKeyList.NONE.key}
              disabled={formData.useDefault}
              onChange={handleChange}
            />
          </Form.Field>
          <Form.Field error={formErrors.requirementKey}>
            <Radio
              label={DocumentRequirementKeyList.SUBMISSION.name}
              name="requirementKey"
              value={DocumentRequirementKeyList.SUBMISSION.key}
              checked={formData.requirementKey === DocumentRequirementKeyList.SUBMISSION.key}
              disabled={formData.useDefault}
              onChange={handleChange}
            />
          </Form.Field>
          <Form.Field error={formErrors.requirementKey}>
            <Radio
              label={DocumentRequirementKeyList.REQUEST_AND_SUBMISSION.name}
              name="requirementKey"
              value={DocumentRequirementKeyList.REQUEST_AND_SUBMISSION.key}
              checked={formData.requirementKey === DocumentRequirementKeyList.REQUEST_AND_SUBMISSION.key}
              disabled={formData.useDefault}
              onChange={handleChange}
            />
          </Form.Field>
        </Form.Group>
      </Form>
      <ErrorsView errors={errors} />
    </>
  );
};

export default EditPermitTypeDocumentTypeSettingsForm;
